<template lang="pug">
v-layout()
  v-flex.box-active-card-documento
    v-layout.box-card-documento(
      @click="clickCard"
      justify-space-around column fill-height
      )
      v-flex.box-card-img-documento
        v-img
          img(:src="iconMain")
      v-flex.box-card-text-documento
        span {{procesarString(text)}}
</template>

<script>

export default {
  props: [
    'text',
    'icon',
    'iconHover'
  ],
  data () {
    return {
      iconMain: null
    }
  },
  computed: {
    activeMethod () {
      return this.activo ? '' : 'box-active-card-documento'
    }
  },
  mounted () {
    let self = this

    self.iconMain = self.icon
  },
  methods: {
    clickCard () {
      this.$emit('cardMethod')
    },
    procesarString (inputString) {
      const parts = inputString.split('.')
      const extension = parts.pop()
      let name = parts.join('').split('_')

      // Verificar que haya al menos 4 partes
      if (name.length >= 4) {
        name = name.splice(3)
        if (!name.includes('Condicionado General Plan Garantizado')) {
          name.pop()
        }
      }
      return `${name.join('_')}.${extension}`
    }
  }
}
</script>

<style scoped>
@media (min-width : 360px) {
  .box-active-card-documento .box-card-documento {
    background-color: #ffffff !important;
  }

  .box-active-card-documento .box-card-text-documento span {
    color: #454A6C;
  }

  .box-card-documento:active {
    border: 1px solid #0855c4
  }

  .box-card-documento {
    position: relative;
    box-sizing: border-box;
    border: 1px solid #F2F2F2;
    height: 10em !important;
    width: 10.6em !important;
    box-shadow: 0px 5px 9px rgb(164 164 164 / 10%);
    border-radius: 15px;
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 12px;
    padding-bottom: 12px;
    cursor: pointer
  }

  .box-card-documento:hover {
    background-color: #f9f9f9 !important;
  }

  .box-card-img-documento img {
    width: 60px !important;
    height: 60px !important;
  }

  /* .box-card-text-documento {} */

  .box-card-text-documento span {
    font-size: 12px;
    color: var(--text-color);
    line-height: initial;
    display: flex;
    word-wrap: break-word;
    word-break: break-all;
    hyphens: auto;
  }

  .box-card-img-documento {
    text-align: right;
    display: flex;
    align-items: center;
    align-self: center;
  }
}

@media (min-width : 1024px) {
  .box-card-documento {
    height: 10em !important;
    width: 9.4em !important;
    padding-top: 20px;
  }

  .box-card-text-documento span {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/CardDocumentoEndoso.vue